import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SafetyControlSurveyChartView } from "src/components/views/erp/safetyControl/SafetyControlSurveyChartView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/safetyControlSurvey/summary")({
	staticData: { title: i18n.t("summary"), legacyViewKey: "safetyControlChartPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SafetyControlSurveyChartView />;
}
